import { Component, computed, signal } from '@angular/core'

import { FormsModule } from '@angular/forms'
import { EntityRef } from 'src/app/shared/models/referenceData'
import { DateRangeFilterStateValue } from 'src/app/shared/services/filter/date-range-filter'
import { DateRangeFilterPickerComponent } from '../date-range-filter-picker/date-range-filter-picker.component'
import { EntitySelectorComponent } from '../entity-selector/entity-selector.component'
import { LabeledPropertyComponent } from '../labeled-property/labeled-property.component'
import { ModalBodyComponent } from '../modals/modal-body/modal-body.component'
import { ModalFooterComponent } from '../modals/modal-footer/modal-footer.component'
import { ModalHeaderComponent } from '../modals/modal-header/modal-header.component'
import { TBillNITSRateCreateRequest } from '../settlements/tbill-settlements.types'
import { NumberInputComponent } from '../number-input/number-input.component'

interface ModalState {
  month: DateRangeFilterStateValue, rate: number, control_area: EntityRef
}

@Component({
  imports: [
    FormsModule,
    ModalHeaderComponent,
    ModalBodyComponent,
    ModalFooterComponent,
    LabeledPropertyComponent,
    DateRangeFilterPickerComponent,
    EntitySelectorComponent,
    NumberInputComponent,
  ],
  selector: 'app-create-tbill-nits-rate-modal',
  styles: '',
  template: `
    <div app-modal-header>Create Schedule 9 Rate</div>

    <div app-modal-body>
        <div app-labeled-property label="Control Area">
            <div
            app-entity-selector
            [slim]="true"
            label="Control Area"
            [config]="{
                resource: 'controlAreas', 
                allowMultiple: false
            }"
            [value]="modalState().control_area"
            (valueChange)="updateControlArea($event)"
            ></div>
        </div>
        <div app-labeled-property label="Month">
            <div dateRangeFilterPicker
            [value]="modalState().month"
            (valueChange)="updateMonth($event)"
            [showOperation]="false"
            [showRange]="false"
            [showTime]="false"
            [showSeconds]="false"
            [onlyMonth]="true"
            ></div>
        </div>
        <div app-labeled-property label="Rate ($/(MW\u00A0MTH))">
            <div app-number-input
            [value]="modalState().rate ?? 0"
            (valueChange)="updateRate($event)"
            ></div>
        </div>
    </div>

    <div app-modal-footer>
        <button
        class="action-btn primary"
        [disabled]="!canCreate()"
        (click)="create()"
        >
        Create
        </button>
        <button class="action-btn" (click)="onCancel()()">Cancel</button>
    </div>
    `,
})
export class CreateTBillNITSRateModalComponent {
  protected readonly modalState = signal<Partial<ModalState>>({})
  protected readonly onCreate = signal<(req: TBillNITSRateCreateRequest) => void>(() => void 0)
  protected readonly onCancel = signal<() => void>(() => void 0)

  canCreate = computed(() => {
    const state = this.modalState()
    return state.month &&
      !Number.isNaN(state.rate) &&
      state.rate != undefined &&
      state.control_area
  })

  init(overrides: Partial<{
    modalState: Partial<ModalState>,
    onCreate: (req: TBillNITSRateCreateRequest) => void,
    onCancel: () => void
  }>) {
    this.modalState.update(v => ({ ...v, ...(overrides.modalState ?? {}) }))
    this.onCreate.update(v => overrides.onCreate ?? v)
    this.onCancel.update(v => overrides.onCancel ?? v)
  }

  updateMonth(month: DateRangeFilterStateValue) {
    this.modalState.update(v => ({ ...v, month }))
  }
  updateControlArea(control_area: EntityRef) {
    this.modalState.update(v => ({ ...v, control_area }))
  }
  updateRate(rate: number) {
    this.modalState.update(v => ({ ...v, rate }))
  }
  create() {
    this.onCreate()({
      month: this.modalState().month!.value as Date,
      rate: this.modalState().rate!,
      control_area_code: this.modalState().control_area!.entity_code,
    })
  }
}
